// import Logo from "../assets/images/app_logox.png";
// import Logo from "../assets/images/app_logo.png";

export function getAppLogo(){
  try{
    return require("../vendor/images/app_logo_2021.png");
  }catch(err){
    return require("../assets/images/app_logo_2021.png");
  }
}
